import { tns } from 'tiny-slider/src/tiny-slider'

export function smallCarousel() {
  document.querySelectorAll('.js-small-carousel').forEach(slider => {
    tns({
      container: slider,
      items: 1,
      nav: true,
      controls: false,
      mouseDrag: true,
      autoplay: true,
      autoplayButton: false,
    });
});
}


// WEBPACK FOOTER //
// ./scripts/partials/small-carousel.js